import request from '@/utils/request'
export function sysOssUpload (data) {
    return request({
        url: '/system/oss/upload',
      method: 'post',
      headers: {
        Accept: 'application/json, text/plain, */*'
      },
        data: data
    })
}

// 删除图片
export function deletesysOss (ossIds) {
    return request({
      url: '/system/oss/' + ossIds,
      method: 'delete'
    })
  }
